export const UI_BUILD_VERSION = '2.6.6';
